<script>
  // A file picker that looks like <Button>. Renders a <label> wrapping a hidden file
  // input — something <Button>'s <button> element can't do — so uploads get the same
  // button styling without inline `btn` classes leaking into pages.
  //
  //   <FileButton size="sm" icon="add" accept="text/csv" onchange={importCsv}>Import from CSV</FileButton>
  import Icon from './ui/icon.svelte'

  let {
    variant = 'default',
    size = 'sm',
    icon = null,
    accept = undefined,
    multiple = false,
    onchange,
    class: className = '',
    children
  } = $props()

  const VARIANTS = {
    default: '',
    primary: 'btn-primary',
    secondary: 'btn-secondary',
    ghost: 'btn-ghost',
    outline: 'btn-outline'
  }
  const SIZES = { xs: 'btn-xs', sm: 'btn-sm', md: '', lg: 'btn-lg' }

  const classes = $derived(['btn', VARIANTS[variant] ?? '', SIZES[size] ?? '', className].filter(Boolean).join(' '))
</script>

<label class={classes}>
  {#if icon}<Icon name={icon} size="sm" />{/if}
  {@render children?.()}
  <input type="file" {accept} {multiple} class="hidden" {onchange} />
</label>
